"use client";

import { useState } from "react";

import { InfoIcon } from "../../../_components/dx-icons";
import type { AnalyticsAttrs } from "../../../_components/ui/analytics-attrs";

import { DxIconButton } from "./dx-icon-button";
import { DxImageViewer } from "./dx-image-viewer";

/**
 * 駐車場などの ⓘ ボタン。タップで拠点案内図を全画面モーダル (DxImageViewer) で大きく表示する。
 * メインビジュアル (ヒーロー画像) の拡大と同じビューアを流用する。中央カードだと案内図が
 * 小さく見えづらいため、ヒーローと同じ全画面表示にする (PC / SP とも)。
 *
 * 呼び出し元 (site-about / room-type-about) が Server Component のため、開閉 state を持つ
 * client 境界としてこの小さなトリガーを挟む。DxImageViewer は open state 駆動 (imperative)。
 */
export function DxImageInfoButton({
  imageUrl,
  title,
  ariaLabel,
  ...analyticsAttrs
}: AnalyticsAttrs & {
  /** 表示する画像 (拠点案内図) の URL。 */
  imageUrl: string;
  /** モーダルの caption / alt。 */
  title: string;
  /** ⓘ ボタンの aria-label。 */
  ariaLabel: string;
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <DxIconButton
        variant="transparent"
        size="xsmall"
        ariaLabel={ariaLabel}
        icon={<InfoIcon />}
        onClick={() => setOpen(true)}
        className="flex-none"
        {...analyticsAttrs}
      />
      {open && (
        <DxImageViewer
          imageUrl={imageUrl}
          altText={title}
          caption={title}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
